module.exports = __webpack_public_path__ + "static/img/sf.e90214df.png";